export const m1l5Solution = `use debug::PrintTrait;
// do not modify code on this line or above

//TODO: Add types to the variables
const NUMBER: felt252 = 3;
const SMALL_NUMBER: u8 = 3_u8;

// do not modify code on this line or below

fn main() {
    NUMBER.print();
    SMALL_NUMBER.print();
}

#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
}`;
